import { ILabel } from 'source/NFR.types';

const Label: React.FC<ILabel> = ({ htmlId, title }) => {
  if (!title) return null;
  return <h2 id={htmlId}>{title}</h2>;
};

Label.displayName = 'Label';

export default Label;
